if (!customElements.get('remove-gift-wrap')) {
  customElements.define(
    'remove-gift-wrap',
    class RemoveGiftWrap extends HTMLAnchorElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }
      get cartItems() { return this.closest('cart-items'); }
      onClick(event) {
        event.preventDefault();
        this.cartItems?.enableLoading?.(this.getAttribute('data-index'));
        const giftWrapping = document.querySelector('gift-wrapping');
        giftWrapping?.removeGiftWrap();
      }
    }, { extends: 'a' }
  );
}

if (!customElements.get('gift-wrapping')) {
  customElements.define(
    'gift-wrapping',
    class GiftWrapping extends HTMLElement {
      constructor() {
        super();
        this.giftWrapId = this.getAttribute('data-gift-wrap-id');
        this.giftWrapping = this.getAttribute('data-gift-wrapping') || '';
        this.cartItemsSize = parseInt(this.getAttribute('cart-items-size')) || 0;
        this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart')) || 0;

        // ВИНАГИ 1 бр. gift wrap, ако е активиран
        this.itemsInCart = 1;
      }

      get selector() {
        return this.querySelector(`[name="attributes[${theme.cartStrings.giftWrapAttribute}]"]`);
      }

      connectedCallback() {
        if (this.dataset.priorityRewards === 'true') {
          this.querySelector('[data-priority-reward-retry]')?.addEventListener('click', () => this.syncPriorityReward().catch(() => {}));
          this.selector?.addEventListener('change', theme.utils.debounce((event) => {
            if (this.rewardEligible) { event.target.checked = true; return; }
            event.target.checked ? this.setGiftWrap() : this.removeGiftWrap();
          }, 300));
          this.syncPriorityReward().catch(() => {});
          return;
        }
        if (this.selector) {
          this.selector.addEventListener('change', theme.utils.debounce((event) => {
            event.target.checked ? this.setGiftWrap() : this.removeGiftWrap();
          }, 300));
        }

        // 1) Ако количката съдържа само gift wrap → махни го
        if (this.cartItemsSize == 1 && this.giftWrapsInCart > 0) {
          return this.removeGiftWrap();
        }
        // 2) Ако gift wrap вече е в количката, но qty ≠ 1 → кламп на 1
        if (this.giftWrapsInCart > 0 && this.giftWrapsInCart !== 1) {
          return this.setGiftWrap();
        }
        // 3) Ако НЯМА gift wrap, но атрибутът е сетнат (потребителят е чекнал) → добави 1
        if (this.giftWrapsInCart === 0 && this.giftWrapping.length > 0) {
          return this.setGiftWrap();
        }
        // 4) НЕ добавяме gift wrap автоматично, ако атрибутът не е сетнат.
      }

      get rewardEligible() {
        return window.mfosPriorityRewards.eligible(this.dataset.qualifyingTotal, this.dataset.currency, this.dataset.priorityGoal);
      }

      async syncPriorityReward() {
        if (window.mfosPriorityRewardSync) {
          try { await window.mfosPriorityRewardSync; } catch (_) { return; }
          if (this.isConnected) return this.syncPriorityReward();
          return;
        }
        const plan = window.mfosPriorityRewards.plan({
          eligible: this.rewardEligible,
          active: this.dataset.rewardActive === 'yes',
          previousPaid: this.dataset.previousPaid || '',
          count: this.giftWrapsInCart,
          selected: this.giftWrapping === theme.cartStrings.giftWrapBooleanTrue,
          hasMerchandise: Number(this.dataset.qualifyingTotal) > 0
        });
        if (!plan) {
          document.documentElement.removeAttribute('data-mfos-priority-sync');
          if (this.selector) {
            this.selector.checked = this.rewardEligible || this.giftWrapsInCart > 0 || this.giftWrapping === theme.cartStrings.giftWrapBooleanTrue;
            this.selector.disabled = this.rewardEligible;
          }
          if (this.cartItemsSize === 1 && this.giftWrapsInCart > 0) return this.removeGiftWrap();
          if (this.giftWrapsInCart > 0 && this.giftWrapsInCart !== 1) return this.setGiftWrap();
          if (this.giftWrapsInCart === 0 && this.giftWrapping.length > 0 && !this.rewardEligible) return this.setGiftWrap();
          return;
        }
        const errorElement = this.querySelector('[data-priority-reward-error]');
        if (errorElement) errorElement.hidden = true;
        this.enableLoading();
        if (this.selector) this.selector.disabled = true;
        document.documentElement.setAttribute('data-mfos-priority-sync', '');
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
        const body = JSON.stringify({
          updates: { [this.giftWrapId]: plan.count },
          attributes: {
            [theme.cartStrings.giftWrapAttribute]: plan.selected ? theme.cartStrings.giftWrapBooleanTrue : '',
            _mfos_priority_reward: plan.active,
            _mfos_priority_paid: plan.previousPaid,
            [this.dataset.rewardOrderAttribute]: plan.complimentary ? this.dataset.rewardOrderValue : ''
          },
          sections,
          sections_url: window.location.pathname
        });
        const pending = (async () => {
          const response = await fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), body });
          const cart = await response.json();
          if (!response.ok || cart.errors) throw new Error('Priority reward update failed');
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'priority-reward', cart });
          document.documentElement.removeAttribute('data-mfos-priority-sync');
        })();
        window.mfosPriorityRewardSync = pending;
        try {
          await pending;
        } catch (error) {
          const currentError = document.querySelector('#CartDrawer [data-priority-reward-error]') || errorElement;
          if (currentError) currentError.hidden = false;
          throw error;
        } finally {
          if (window.mfosPriorityRewardSync === pending) window.mfosPriorityRewardSync = null;
          const loader = this.querySelector('.loader');
          if (loader) loader.hidden = true;
          if (!document.documentElement.hasAttribute('data-mfos-priority-sync') && this.selector) this.selector.disabled = this.rewardEligible;
        }
      }

      setGiftWrap() {
        this.enableLoading();
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          updates: {
            [this.giftWrapId]: 1 // винаги 1
          },
          attributes: {
            [theme.cartStrings.giftWrapAttribute]: theme.cartStrings.giftWrapBooleanTrue
          },
          sections: sectionsToBundle
        });

        this.fetchGiftWrap(body);
      }

      removeGiftWrap() {
        this.enableLoading();
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          updates: {
            [this.giftWrapId]: 0
          },
          attributes: {
            [theme.cartStrings.giftWrapAttribute]: '',
            [theme.cartStrings.giftNoteAttribute]: ''
          },
          sections: sectionsToBundle
        });

        this.fetchGiftWrap(body);
      }

      fetchGiftWrap(body) {
        fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrapping', cart: parsedState });
          })
          .catch((error) => { console.log(error); });
      }

      enableLoading() {
        const loader = this.querySelector('.loader');
        if (loader) loader.hidden = false;
      }
    }
  );
}

if (!customElements.get('gift-note')) {
  customElements.define(
    'gift-note',
    class GiftNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', theme.utils.debounce(this.onChange.bind(this), 300));
      }
      onChange(event) {
        const body = JSON.stringify({
          attributes: {
            [theme.cartStrings.giftNoteAttribute]: event.target.value
          }
        });
        fetch(theme.routes.cart_update_url, {...theme.utils.fetchConfig(), ...{ body }});
      }
    }
  );
}

if (!customElements.get('gift-wrap-selector')) {
  customElements.define(
    'gift-wrap-selector',
    class GiftWrapSelector extends HTMLElement {
      constructor() {
        super();
        this.giftWrapId = this.getAttribute('data-gift-wrap-id');
        this.lineItemIndex = parseInt(this.getAttribute('data-line-item-index')) || 0;
        this.giftItemIndex = parseInt(this.getAttribute('data-gift-item-index')) || 0;
      }

      get cartItems() { return this.closest('cart-items'); }
      get lineItem() {
        const item = this.querySelector('script[type="application/json"][data-line-item]')?.textContent;
        return !!item ? JSON.parse(item) : {};
      }
      get giftItem() {
        const item = this.querySelector('script[type="application/json"][data-gift-item]')?.textContent;
        return !!item ? JSON.parse(item) : {};
      }

      connectedCallback() {
        this.addEventListener('change', this.onChange.bind(this));

        if (this.lineItem.properties[theme.cartStrings.giftWrapAttribute] === theme.cartStrings.giftWrapBooleanTrue && !this.giftItem.hasOwnProperty('key')) {
          this.unsetGiftWrap();
        }
      }

      onChange(event) {
        event.preventDefault();
        event.stopPropagation();
        const input = event.target;
        const isChecked = input.type == 'checkbox' ? input.checked : input.value == theme.cartStrings.giftWrapBooleanTrue;
        isChecked ? this.setGiftWrap() : this.unsetGiftWrap();
      }

      setGiftWrap() {
        this.cartItems?.enableLoading?.(this.lineItem.key);

        // 1) Махаме реда на целевия продукт
        let body = JSON.stringify({ id: this.lineItem.key, quantity: 0 });
        fetch(theme.routes.cart_change_url, { ...theme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.errors) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap', cart: parsedState });
              return;
            }

            // 2) Добавяме отново продукта + gift wrap с qty=1
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

            const lineItemProps = {
              ...this.lineItem.properties,
              [theme.cartStrings.giftWrapAttribute]: theme.cartStrings.giftWrapBooleanTrue
            };

            body = JSON.stringify({
              items: [
                {
                  id: this.lineItem.variant_id,
                  quantity: this.lineItem.quantity,
                  properties: lineItemProps
                },
                {
                  id: this.giftWrapId,
                  quantity: 1, // ВИНАГИ 1
                  properties: {
                    [theme.cartStrings.targetProductAttribute]: this.lineItem.title
                  },
                  parent_id: this.lineItem.variant_id
                }
              ],
              sections: sectionsToBundle
            });

            fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body })
              .then((response) => response.json())
              .then(async (parsedState) => {
                const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET')})).json();
                cartJson['sections'] = parsedState['sections'];
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap', cart: cartJson });
              });
          })
          .catch((error) => { console.error(error); });
      }

      unsetGiftWrap() {
        this.cartItems?.enableLoading?.(this.lineItem.key);

        // Премахваме целевия продукт и gift wrap
        let updates = { [this.lineItem.key]: 0 };
        if (this.giftItem.hasOwnProperty('key')) updates[this.giftItem.key] = 0;

        let body = JSON.stringify({ updates });

        fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            if (parsedState.errors) {
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap', cart: parsedState });
              return;
            }

            // Връщаме целевия продукт без gift wrap
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

            const lineItemProps = { ...this.lineItem.properties };
            delete lineItemProps[theme.cartStrings.giftWrapAttribute];

            body = JSON.stringify({
              id: this.lineItem.variant_id,
              quantity: this.lineItem.quantity,
              properties: lineItemProps,
              sections: sectionsToBundle
            });

            fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body })
              .then((response) => response.json())
              .then(async (parsedState) => {
                const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET')})).json();
                cartJson['sections'] = parsedState['sections'];
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap', cart: cartJson });
              });
          })
          .catch((error) => { console.error(error); });
      }
    }
  );
}

if (!customElements.get('gift-wrap-item')) {
  customElements.define(
    'gift-wrap-item',
    class GiftWrapItem extends HTMLElement {
      constructor() { super(); }

      get sectionId() { return this.getAttribute('data-section-id'); }
      get giftSection() { return this.closest('.cart__gift'); }

      get lineItem() {
        const item = this.querySelector('script[type="application/json"][data-line-item]')?.textContent;
        return !!item ? JSON.parse(item) : {};
      }
      get giftItem() {
        const item = this.querySelector('script[type="application/json"][data-gift-item]')?.textContent;
        return !!item ? JSON.parse(item) : {};
      }

      connectedCallback() {
        // Ако gift wrap вече е в количката, клампни qty на 1
        const qty = this.giftItem.quantity || 0;
        if (this.giftItem.key && qty !== 1) {
          this.updateGiftWrap(this.giftItem.key, 1);
        }
      }

      updateGiftWrap(line, _quantityIgnored) {
        this.enableLoading(line);

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          id: line,
          quantity: 1, // винаги 1
          sections: sectionsToBundle
        });

        fetch(theme.routes.cart_change_url, { ...theme.utils.fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((parsedState) => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap', cart: parsedState });
          })
          .catch((error) => { console.error(error); });
      }

      enableLoading(line) {
        this.giftSection?.classList?.add('pointer-events-none');
        const loader = document.getElementById(`Loader-${this.sectionId}-${line}`);
        if (loader) loader.hidden = false;
      }
    }
  );
}

if (!customElements.get('unset-gift-wrap')) {
  customElements.define(
    'unset-gift-wrap',
    class UnsetGiftWrap extends HTMLAnchorElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
      }
      get giftWrapItem() { return this.closest('gift-wrap-item'); }
      onClick(event) {
        event.preventDefault();
        this.giftWrapItem.updateGiftWrap(this.getAttribute('data-index'), 0);
      }
    }, { extends: 'a' }
  );
}

if (!window.mfosPriorityCheckoutGuard) {
  window.mfosPriorityCheckoutGuard = true;
  document.addEventListener('click', (event) => {
    if (document.documentElement.hasAttribute('data-mfos-priority-sync') && event.target.closest('[name="checkout"], a[href^="/checkout"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', (event) => {
    if (document.documentElement.hasAttribute('data-mfos-priority-sync') && event.submitter?.name === 'checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}
